import coreRoutes from '@glittr/frontend-core/src/routes';
import Home from './views/pages/index.vue';

export default {
  mode: 'history',
  base: process.env!.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    ...coreRoutes,
    {
      path: '/_widgets/digital-donation-receipt',
      name: 'event-detail',
      component: () => import('./views/widgets/digital-donation-receipt/digital-donation-receipt.vue'),
    },
    {
      path: '/:tenant/:workspace/widgets/digital-donation-receipt-config',
      name: 'event-detail-configuration',
      component: () => import('./views/widgets/digital-donation-receipt/digital-donation-receipt-config.vue'),
    },
    {
      path: '/:tenant/:workspace',
      name: 'dashboard',
      component: () => import('./views/pages/app/dashboard.vue'),
    },
  ],
};
